import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "@redux/firebase";

/**
 * Uploads a WAV audio blob to Firebase Storage for an exam answer.
 * Non-blocking: returns null on failure so the exam flow is never disrupted.
 *
 * @param {Blob} audioBlob - WAV audio blob
 * @param {string} userId - Current user ID
 * @param {string} examId - Current exam session ID
 * @param {number} questionIndex - Zero-based question index
 * @returns {Promise<string|null>} Download URL or null on failure
 */
export async function uploadExamAudio(audioBlob, userId, examId, questionIndex) {
  try {
    if (!audioBlob || !userId || !examId) {
      console.warn('[uploadExamAudio] Missing required parameters, skipping upload');
      return null;
    }

    const timestamp = Date.now();
    const filename = `q${questionIndex}_${timestamp}.wav`;
    const storagePath = `exams/${userId}/${examId}/${filename}`;

    const storageRef = ref(storage, storagePath);
    const uploadResult = await uploadBytes(storageRef, audioBlob);
    const downloadURL = await getDownloadURL(uploadResult.ref);

    console.log(`[uploadExamAudio] Uploaded audio for q${questionIndex}: ${storagePath}`);
    return downloadURL;
  } catch (error) {
    console.error('[uploadExamAudio] Upload failed, continuing without audio:', error.message);
    return null;
  }
}
